<template>
  <div class="forgot-page">
    <!-- 顶部栏 -->
    <div class="forgot-header">
      <div class="header-title">忘记密码</div>
      <div class="header-back" @click="goBack">
        <img class="back-icon" src="@/assets/image/frame.png" />
        <span class="back-text">返回</span>
      </div>
    </div>

    <!-- 表单卡片 -->
    <div class="forgot-card">
      <div class="forgot-form">
        <div class="form-item">
          <div class="form-label">手机号</div>
          <input v-model="form.phone" type="text" placeholder="请输入手机号" maxlength="11" class="form-input" @input="form.phone = form.phone.replace(/[^\d]/g, '')" />
        </div>

        <div class="form-item" style="margin-top: 20px">
          <div class="form-label">验证码</div>
          <div class="sms-row">
            <input v-model="form.smsCode" type="text" placeholder="请输入验证码" class="form-input" />
            <button class="sms-btn" :disabled="smsCountdown > 0" @click="sendSmsCode">
              {{ smsCountdown > 0 ? `${smsCountdown}s` : "获取验证码" }}
            </button>
          </div>
        </div>

        <div class="form-item" style="margin-top: 20px">
          <div class="form-label">新密码</div>
          <div class="password-input-wrapper">
            <input v-model="form.password" :type="showPassword ? 'text' : 'password'" placeholder="请输入新密码" class="form-input" />
            <img class="password-toggle" :src="showPassword ? showImg : showNoImg" @click="showPassword = !showPassword" />
          </div>
        </div>

        <div class="form-item" style="margin-top: 20px">
          <div class="form-label">确认密码</div>
          <div class="password-input-wrapper">
            <input v-model="form.confirmPassword" :type="showConfirmPassword ? 'text' : 'password'" placeholder="请再次输入密码" class="form-input" />
            <img class="password-toggle" :src="showConfirmPassword ? showImg : showNoImg" @click="showConfirmPassword = !showConfirmPassword" />
          </div>
        </div>

        <button class="forgot-submit" @click="handleSubmit">立即登录</button>
      </div>
    </div>
  </div>
</template>

<script>
import { getVerCode, forgetPass } from "@/api";

export default {
  name: "ForgotPassword",
  data() {
    return {
      form: {
        phone: "",
        smsCode: "",
        password: "",
        confirmPassword: "",
      },
      showPassword: false,
      showConfirmPassword: false,
      showImg: require("@/assets/image/show.png"),
      showNoImg: require("@/assets/image/show-no.png"),
      smsCountdown: 0,
      smsTimer: null,
      submitting: false,
    };
  },
  beforeDestroy() {
    if (this.smsTimer) {
      clearInterval(this.smsTimer);
    }
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    sendSmsCode() {
      if (!this.form.phone) {
        this.$message.warning("请输入手机号");
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(this.form.phone)) {
        this.$message.warning("请输入正确的手机号");
        return;
      }
      getVerCode({ phoneNumber: this.form.phone })
        .then(() => {
          this.$message.success("验证码已发送");
          this.smsCountdown = 60;
          this.smsTimer = setInterval(() => {
            this.smsCountdown--;
            if (this.smsCountdown <= 0) {
              clearInterval(this.smsTimer);
            }
          }, 1000);
        })
        .catch((err) => {
          this.$message.error(err.message || "验证码发送失败");
        });
    },
    async handleSubmit() {
      if (!this.form.phone || !/^1[3-9]\d{9}$/.test(this.form.phone)) {
        this.$message.warning("请输入正确的手机号");
        return;
      }
      if (!this.form.smsCode) {
        this.$message.warning("请输入验证码");
        return;
      }
      if (!this.form.password) {
        this.$message.warning("请输入新密码");
        return;
      }
      if (!this.form.confirmPassword) {
        this.$message.warning("请再次输入密码");
        return;
      }
      if (this.form.password !== this.form.confirmPassword) {
        this.$message.warning("两次输入的密码不一致");
        return;
      }
      if (this.submitting) return;
      this.submitting = true;
      try {
        const res = await forgetPass({
          phoneNumber: this.form.phone,
          verCode: this.form.smsCode,
          password: this.form.password,
        });
        if (res.code === 200) {
          this.$message.success("密码重置成功");
          this.$router.push("/login");
        } else {
          this.$message.error(res.msg || res.message || "密码重置失败");
        }
      } catch (error) {
        this.$message.error(error.message || "密码重置失败");
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped>
.forgot-page {
  min-height: 100vh;
  background: #e8f0fe;
}

.forgot-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 360px 0 360px;
}

.header-title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
}

.header-back {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #666;
  font-size: 14px;
}

.back-icon {
  width: 24px;
  height: 24px;
}

.back-text {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 22px;
  color: #333333;
  margin-left: 6px;
}

.forgot-card {
  width: 690px;
  margin: 80px auto 0;
  background: #fff;
  border-radius: 30px;
  padding: 50px 0;
}

.forgot-form {
  padding: 0 50px;
}

.form-label {
  font-size: 20px;
  color: #333;
  margin-bottom: 9px;
}

.form-input {
  width: 100%;
  height: 60px;
  padding: 0 12px;
  border: 1px solid #e0e0e0;
  border-radius: 14px;
  font-size: 20px;
  box-sizing: border-box;
  outline: none;
}

.form-input:focus {
  border-color: #1869ff;
}

.password-input-wrapper {
  position: relative;
}

.password-input-wrapper .form-input {
  padding-right: 48px;
}

.password-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  width: 26px;
  height: 26px;
  cursor: pointer;
  user-select: none;
}

.password-toggle:hover {
  opacity: 0.7;
}

.sms-row {
  display: flex;
  gap: 8px;
  position: relative;
}

.sms-row .form-input {
  flex: 1;
}

.sms-btn {
  border: unset;
  background: rgba(0, 0, 0, 0);
  color: #1869ff;
  cursor: pointer;
  font-size: 20px;
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
}

.sms-btn:disabled {
  border-color: unset;
  color: #1869ff;
  cursor: not-allowed;
}

.forgot-submit {
  width: 100%;
  height: 60px;
  background: #1869ff;
  color: #fff;
  border: none;
  border-radius: 14px;
  font-size: 20px;
  cursor: pointer;
  margin-top: 50px;
}
</style>
